import { render, staticRenderFns } from "./SectionVideoPopup.vue?vue&type=template&id=7ccd0318&scoped=true&"
import script from "./SectionVideoPopup.vue?vue&type=script&lang=js&"
export * from "./SectionVideoPopup.vue?vue&type=script&lang=js&"
import style0 from "./SectionVideoPopup.vue?vue&type=style&index=0&id=7ccd0318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccd0318",
  null
  
)

export default component.exports